import { FaSolid } from '../interfaces/fa-solid.interface';

export const faSolid: FaSolid = {
  checkToSlot: 'fa-solid fa-check-to-slot',
  circleInfo: 'fa-solid fa-circle-info',
  doorClosed: 'fa-solid fa-door-closed',
  gear: 'fa-solid fa-gear',
  housePersonLeave: 'fa-solid fa-house-person-leave',
  locationDot: 'fa-solid fa-location-dot',
  personSimple: 'fa-solid fa-person-simple',
  sparkles: 'fa-solid fa-sparkles',
  userCheck: 'fa-solid fa-user-check',
  userClock: 'fa-solid fa-user-clock',
  xMark: 'fa-solid fa-xmark',
  spinner: 'fa-solid fa-spinner fa-spin',
  circleNotch: 'fa-solid fa-circle-notch fa-spin',
  messageSmile: 'fa-solid fa-message-smile',
  arrowDown: 'fa-solid fa-arrow-down',
  star: 'fa-solid fa-star',
  checkCircle: 'fa-solid fa-check-circle',
  triangleExclamation: 'fa-solid fa-triangle-exclamation'
};
